<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import ProductService from '@/services/product';
import CompanyService from '@/services/company';

moment.locale('pt-BR');

export default {
  page: {
    title: "Listagem de Estoque",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Listagem de Estoque",
      loading: false,
      products: [],
      searchParams: {
        product: '',
        company: '',
      },
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      fields: [
        { key: 'code', sortable: true, label: 'Código' },
        { key: 'description', sortable: true, label: 'Produto', formatter: (value, key, item) => {
          return `${item.description} ${item.complement}`
        } },
        { key: 'company.name', sortable: true, label: 'Filial' },
        { key: 'stock', sortable: true, label: 'Estoque' },
      ],
      companies: [],
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      this.loadProducts();
    },
    async loadProducts(page = 1, showLoading = true) {
      if (showLoading) {
        this.loading = true;
      }

      if (this.companies.length === 0) {
        const companies = await CompanyService.getAll();
        this.companies = companies.data;

        if (this.companies && this.companies.length > 0) {
          this.searchParams.company = this.companies[0].code;
        }
      }

      ProductService.getStock(page, this.searchParams.product, this.searchParams.company)
        .then(res => {
          this.loading = false;

          this.products = res.data.products;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadProducts(this.currentPage);
    },
    exportData() {
      this.loading = true;

      ProductService.exportStock(this.searchParams.product, this.searchParams.company).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'ListagemEstoque.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Busca</label>
                    <input type="text" v-model="searchParams.product" class="form-control" placeholder="Código ou descrição do produto" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Empresa</label>
                    <select
                      v-model="searchParams.company"
                      class="form-control"
                      name="activityType"
                    >
                      <option v-for="company of companies" :key="company._id" :value="company.code">{{company.name}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="products"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }
</style>